
import Tooltip from '05-ui-kit/lib/Tooltip';
import { Button, StatusBlock, Toggle } from '05-ui-kit';
import { computed, inject, onMounted, ref } from '@vue/composition-api';
import { useContext } from '@nuxtjs/composition-api';
import { storeToRefs } from 'pinia';
import TSProductPromo from '~/components/ts-components/TSProductPromo/TSProductPromo.vue';
import TSProductCard from '~/components/ts-components/TSProductCard/TSProductCard.vue';
import type { EmitteryType } from '~/plugins/emitter';
import type { Seller } from '~/type/Seller';
import ProductPriceBlock from '~/components/ProductPrice/ProductPriceBlock.vue';
import type { Comment as CommentType } from '~/type/Comment';
import ActionCart from '~/action/ActionCart.vue';
import UIActionEntity from '~/data/UIActionEntity/UIActionEntity.vue';
import UIActionList from '~/data/UIActionList/UIActionList.vue';
import ViewportToogle from '~/components/ViewportToogle/ViewportToogle.vue';
import RowSliderNew from '~/components/sliders/RowSliderNew/RowSliderNew.vue';
import Comment from '~/components/review-component/Comment/Comment.vue';
import Review from '~/components/review-component/Review/Review.vue';
import AddToCart from '~/components/AddToCart/AddToCart.vue';
import QuickOrderToggle from '~/components/product/QuickOrderToggle/QuickOrderToggle.vue';
import FoundCheaper from '~/components/FoundCheaper/FoundCheaper.vue';
import { useReportStore } from '~/store/modal/report';
import ProductEmptyBlock from '~/components/ProductEmptyBlock/ProductEmptyBlock.vue';
import UserTools from '~/components/UserTools/UserTools.vue';
import SellerList from '~/components/SellerList/SellerList.vue';
import SaleMarkerList from '~/components/SaleMarkerList/SaleMarkerList.vue';
import InfoBlockLargeEquipment from '~/components/InfoBlockLargeEquipment/InfoBlockLargeEquipment.vue';
import Specifications from '~/components/Specifications/Specifications.vue';
import ReviewRating from '~/components/review-component/ReviewRating/ReviewRating.vue';
import ReviewComment from '~/components/review-component/ReviewComment/ReviewComment.vue';
import ReviewMobile from '~/components/review-component/Review/ReviewMobile.vue';
import RichContent from '~/components/RichContent/RichContent.vue';
import ProductStatistics from '~/components/ProductStatistics/ProductStatistics.vue';
import { useLocationStore } from '~/store/location';
import { useCartStore } from '~/store/cart';
import { useUserStore } from '~/store/user';
import { getStatusPromo } from '~/helper/getStatusPromo';
import PromoBanner from '~/components/banner/PromoBanner.vue';
import SaleBanner from '~/components/banner/SaleBanner.vue';
import LazyLoan from '~/components/Loan/Loan.vue';
import DeliveryType from '~/components/DeliveryType/DeliveryType.vue';
const __sfc_main = {};
__sfc_main.props = {
  response: {
    key: "response",
    required: true,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const context = useContext();
  const emitter = inject<EmitteryType>('emitter')!;
  const {
    currentCity
  } = storeToRefs(useLocationStore());
  const currentSeller = ref<Seller>();
  const {
    enableReport
  } = useReportStore();
  const {
    data: cartData
  } = storeToRefs(useCartStore());
  const {
    user: userData
  } = useUserStore();
  const cartList = computed(() => cartData.value);
  const cartCount = computed(() => cartList.value?.[props.response.product.id]?.quantity || 0);
  const price = computed(() => props.response.product.price?.common?.value);
  const isPreOrder = computed(() => props.response.product.status?.code === 'PRE_ORDER');
  const isShowSuggestorButton = ref(false);
  currentSeller.value = props.response.product.seller?.[0];
  function addAnswerHandler(id: string, {
    result
  }: {
    result: any;
  }) {
    if (Array.isArray(props.response.product.question.find(item => item.id === id)?.answer)) props.response.product.question.find(item => item.id === id)?.answer.push(result);else props.response.product.question.find(item => item.id === id)!.answer = [result];
  }
  function onClickBuyCredit() {
    const orderNumber = `TI-${Math.floor(Math.random() * 999999) + 1}|${props.response.product.id}|${userData?.id ? userData.id : 'guest'}|${currentCity?.value?.id}`;
    tinkoff.create({
      orderNumber,
      shopId: context.env.TINKOFF_SHOP_ID,
      showcaseId: context.env.TINKOFF_SHOWCASE_ID,
      items: [{
        name: props.response.product.name,
        price: price.value,
        quantity: 1
      }],
      sum: price.value
    });
  }
  function onError({
    response
  }: {
    response: {
      error: {
        description?: string;
      };
    };
  }) {
    Tooltip({
      title: response?.error?.description ?? 'Ошибка при отправке комментария, попробуйте позже',
      description: '',
      type: 'error',
      mobileOffset: [5, 5, 63, 5]
    });
  }
  function recalculateLikes({
    send,
    data,
    param,
    param2
  }: {
    send: () => void;
    data: CommentType;
    param: 'like' | 'dislike';
    param2: 'like' | 'dislike';
  }): void {
    /**
      * Устанавливает количество лайков/дизлайков и также их активность
      */
    if (data[param]) {
      data[param]!.count = data[param]?.active ? data[param]!.count - 1 : data[param]!.count + 1;
      data[param]!.active = !data[param]?.active;
      if (data[param]?.active && data[param2]?.active) {
        data[param2]!.count--;
        data[param2]!.active = false;
      }
      send();
    }
  }
  function onSuccessQuickOrder({
    response
  }: {
    response: Awaited<ReturnType<typeof context.$api.product.buyOneClick>>;
  }) {
    emitter.emit('after-checkout', {
      userId: userData?.id,
      order: {
        id: response.result?.ORDER_ID,
        product: [{
          ...props.response?.product,
          offer: props.response?.offer
        }],
        bonus: {
          income: props.response?.product?.price?.bonus
        }
      }
    });
  }
  function onSuccessAddedComment({
    toggleShow
  }: {
    toggleShow: () => void;
  }) {
    Tooltip({
      type: 'success',
      title: 'Комментарий отправлен на модерацию!',
      mobileOffset: [5, 5, 63, 5],
      description: ''
    });
    toggleShow();
  }
  const promoProductText = computed(() => {
    const saleList = {
      installment: [961466, 961469, 961472, 961475, 961604],
      preparation: [961439, 961442, 961445, 961448]
    };
    return props.response.product?.sale.map((el): {
      type: 'installment' | 'preparation';
      id: number;
    } | undefined => {
      if (saleList.installment.includes(el.id)) return {
        type: 'installment',
        id: el.id
      };else if (saleList.preparation.includes(el.id)) return {
        type: 'preparation',
        id: el.id
      };
    }).filter(item => item !== undefined)[0];
  });
  function saleActiveTime() {
    return getStatusPromo({
      startDate: '2024.08.18',
      endDate: '2024.10.01'
    });
  }
  onMounted(() => {
    isShowSuggestorButton.value = Boolean(localStorage.getItem('suggestor'));
  });
  return {
    emitter,
    currentSeller,
    enableReport,
    cartCount,
    price,
    isPreOrder,
    isShowSuggestorButton,
    addAnswerHandler,
    onClickBuyCredit,
    onError,
    recalculateLikes,
    onSuccessQuickOrder,
    onSuccessAddedComment,
    promoProductText,
    saleActiveTime
  };
};
__sfc_main.components = Object.assign({
  ProductStatistics,
  Button,
  UserTools,
  SellerList,
  PromoBanner,
  SaleBanner,
  InfoBlockLargeEquipment,
  SaleMarkerList,
  ProductPriceBlock,
  ActionCart,
  AddToCart,
  LazyLoan,
  UIActionEntity,
  QuickOrderToggle,
  DeliveryType,
  Toggle,
  FoundCheaper,
  ViewportToogle,
  RowSliderNew,
  TSProductCard,
  TSProductPromo,
  RichContent,
  Specifications,
  StatusBlock,
  ReviewRating,
  UIActionList,
  Review,
  ReviewComment,
  Comment,
  ReviewMobile,
  ProductEmptyBlock
}, __sfc_main.components);
export default __sfc_main;
